import axiosIns from '@/libs/axios'
import { syncWatchers, toWatcherForm } from '@/libs/watchers'
import { definitionId } from '@/libs/definitions'

const ROOT_URL = '/Admin/data/tasks'
const WATCHERS_URL = '/Admin/data/task_watchers'

export default {
  namespaced: true,
  state: {
    loading: false,
    dataList: [],
    dataCounts: 0,
    dataItem: {
      id: null,
      id_licenses: null,
      title: null,
      description: null,
      id_task_priorities: definitionId('priority', 'low'),
      id_task_statuses: definitionId('task', 'open'),
      id_projects: null,
      id_manager_users: [],
      is_public: 1,
      watcher_users: [],
      watcher_teams: [],
      id_departments: null,
      id_teams: null,
      start_date: null,
      target_date: null,
      completed_date: null,
      total_duration: 0,
      repeat_type: null,
      repeat_interval: null,
      repeat_config: null,
      next_repeat_date: null,
      id_parent_tasks: null,
      id_users: null,
      subtaskCount: 0,
      watchers_can_update: 0,
    },
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
    filterParams: {
      keywords: null,
      status: null,
      priority: null,
      id_projects: null,
      date_start: null,
      date_end: null,
    },
  },
  getters: {
    loading(state) {
      return state.loading
    },
    dataList(state) {
      return state.dataList
    },
    dataCounts(state) {
      return state.dataCounts
    },
    dataItem(state) {
      return state.dataItem
    },
    dataSaveStatus(state) {
      return state.dataSave
    },
    filterParams(state) {
      return state.filterParams
    },
  },
  mutations: {
    SET_LOADING(state, data) {
      state.loading = data
    },
    SET_DATA_LIST(state, data) {
      state.dataList = data
    },
    SET_DATA_ITEM(state, data) {
      state.dataItem = data
    },
    SET_DATA_COUNTS(state, data) {
      state.dataCounts = data
    },
    SET_DATA_SAVE(state, data) {
      state.dataSave = data
    },
    RESET_DATA_ITEM(state) {
      state.dataItem = {
        id: null,
        id_licenses: null,
        title: null,
        description: null,
        id_task_priorities: definitionId('priority', 'low'),
        id_task_statuses: definitionId('task', 'open'),
        id_projects: null,
        id_manager_users: [],
        is_public: 1,
        watcher_users: [],
        watcher_teams: [],
        id_departments: null,
        id_teams: null,
        start_date: null,
        target_date: null,
        completed_date: null,
        total_duration: 0,
        repeat_type: null,
        repeat_interval: null,
        repeat_config: null,
        next_repeat_date: null,
        id_parent_tasks: null,
        id_users: null,
        subtaskCount: 0,
        watchers_can_update: 0,
      }
    },
  },
  actions: {
    getDataList({ commit }, params) {
      commit('SET_LOADING', true)
      commit('RESET_DATA_ITEM')
      commit('SET_DATA_LIST', [])
      const data = JSON.stringify(params || {})
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_DATA_COUNTS', response.data.count)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
    async getDataItem({ commit }, id) {
      if (Number(id)) {
        commit('SET_LOADING', true)
        commit('RESET_DATA_ITEM')
        const requestData = {
          where: {
            'tasks.id': id,
          },
          array: false,
        }
        return axiosIns
          .post(ROOT_URL, requestData)
          .then(response => {
            // Yetkisiz veya olmayan kayıtta BE boş sonuç döner; form varsayılanları korunur.
            const row = response.data.data
            if (row && row.id) commit('SET_DATA_ITEM', toWatcherForm(row))
            commit('SET_LOADING', false)
            return row && row.id ? row : null
          })
          .catch(error => {
            commit('SET_LOADING', false)
            console.error(error)
          })
      }
      return false
    },
    async saveData({ commit }, postData) {
      commit('SET_LOADING', true)
      try {
        // BE boş diziyi kolona yazamıyor; yöneticisiz kayıt NULL gönderilir.
        const payload = Array.isArray(postData.id_manager_users) && !postData.id_manager_users.length
          ? { ...postData, id_manager_users: null }
          : postData
        const { data } = await axiosIns.post(`${ROOT_URL}/saveData`, JSON.stringify(payload))
        const result = { ...data }
        // Herkese açıkta gözlemci kayıtları korunur, kutu kapanınca aynı seçimler geri gelir.
        if (data.status && postData.is_public === 0 && Array.isArray(postData.watcher_users)) {
          result.watcherError = !(await syncWatchers(WATCHERS_URL, 'id_tasks', data.id, postData))
        }
        commit('SET_DATA_SAVE', result)
        commit('SET_LOADING', false)
        return result
      } catch (error) {
        commit('SET_LOADING', false)
        const httpStatus = error?.response?.status
        if (httpStatus >= 400 && httpStatus < 500 && error.response.data?.status === false) {
          commit('SET_DATA_SAVE', error.response.data)
          return error.response.data
        }
        throw error
      }
    },
    completeTask({ commit }, { id, closing_note }) {
      commit('SET_LOADING', true)
      const data = JSON.stringify({ id, closing_note })
      return axiosIns
        .post(`${ROOT_URL}/complete`, data)
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
          commit('SET_LOADING', false)
          return response.data
        })
        .catch(error => {
          commit('SET_LOADING', false)
          if (error?.response?.status === 400 && error.response.data?.status === false) {
            commit('SET_DATA_SAVE', error.response.data)
            return error.response.data
          }
          return Promise.reject(error)
        })
    },
    reopenTask({ commit }, id) {
      commit('SET_LOADING', true)
      return axiosIns
        .post(`${ROOT_URL}/reopen`, JSON.stringify({ id }))
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
          commit('SET_LOADING', false)
          return response.data
        })
        .catch(error => {
          commit('SET_LOADING', false)
          if (error?.response?.data?.status === false) {
            commit('SET_DATA_SAVE', error.response.data)
            return error.response.data
          }
          return Promise.reject(error)
        })
    },
    removeData({ commit }, id) {
      commit('SET_LOADING', true)
      return axiosIns
        .post(`${ROOT_URL}/deleteData`, { id })
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
          commit('SET_LOADING', false)
          return response.data.status
        })
        .catch(error => console.error(error))
    },
  },
}
